exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 760px) {\n.footer-nav__content {\n    position: static !important;\n}\n}", ""]);

// exports
